import { useCallback } from 'react'

import { DateTimeColOptionsOnly, getDefaultLocale } from '@makyoapp/makyo-common'

import useAuth from './useAuth'

function getLocale(colOptions: DateTimeColOptionsOnly, userLocale: string) {
  if (colOptions.dtDateFormatType !== 'fixed') {
    return userLocale
  }

  return colOptions.dtLocale || 'en-US'
}
export function useLocaleColOrUser(colOptions: DateTimeColOptionsOnly) {
  const userLocale = useUserLocale()
  return getLocale(colOptions, userLocale)
}

export function useLocaleColOrUserCb() {
  const userLocale = useUserLocale()
  return useCallback(
    (colOptions: DateTimeColOptionsOnly) => {
      return getLocale(colOptions, userLocale)
    },
    [userLocale]
  ) as (colOptions: unknown) => string
}

export function useUserLocale() {
  const { userData } = useAuth()
  return userData?.locale || getDefaultLocale()
}
